/**
 * Shell copy for `src/stores` (keys: `shell.stores.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  analyticsStore: {
    couldNotLoadWatchlists: 'Could not load the watchlists.',
    couldNotLoadInfluencers: 'Could not load the influencers.',
    couldNotLoadCompetitors: 'Could not load the competitors.',
    couldNotLoadTheCapabilities: 'Could not load the capabilities.',
    summaryUnavailable: 'Summary unavailable.',
    audienceGrowthUnavailable: 'Audience growth unavailable.',
  },
  approvalsStore: {
    errorStatus: 'Error {{status}}',
    unknownError: 'Unknown error',
  },
  contentStore: {
    couldNotLoadContents: 'Could not load the content.',
    accessDeniedSignInAgain: 'Access denied — sign in again.',
  },
  copilotStore: {
    copilotBackendNotDeployedYourMessages: 'Copilot backend not deployed — your messages are kept locally.',
    insufficientAiCreditsTopUpYour: 'Insufficient AI credits — top up your balance (Credits badge, header) to keep using the copilot.',
    tooManyRequestsLimitTemporarilyReached: 'Too many requests — limit temporarily reached. Wait a moment, then try again.',
    copilotTemporarilyUnreachableCheckYourCo: 'Copilot temporarily unreachable — check your connection and try again.',
    theCopilotHitATemporaryError: 'The copilot hit a temporary error. Try again in a moment.',
    rejectedByTheUser: 'Rejected by the user',
    executionStoppedByTheUser: 'Execution stopped by the user',
    userConfirmationContinue: 'User confirmation: continue',
  },
  crmStore: {
    couldNotLoadContacts: 'Could not load the contacts.',
    couldNotLoadCompanies: 'Could not load the companies.',
    couldNotLoadPipelines: 'Could not load the pipelines.',
    accessDeniedSignInAgain: 'Access denied — sign in again.',
    couldNotLoadTheGroups: 'Could not load the groups.',
    couldNotLoadTheRules: 'Could not load the rules.',
  },
  designStore: {
    couldNotLoadDesigns: 'Could not load the designs.',
    couldNotLoadDesign: 'Could not load the design.',
    couldNotLoadBrandKits: 'Could not load the brand kits.',
    accessDeniedSignInAgain: 'Access denied — sign in again.',
    couldNotLoadTheTemplates: 'Could not load the templates.',
  },
  outreachStore: {
    errorStatus: 'Error {{status}}',
    unknownError: 'Unknown error',
    sequencesServiceTimedOut: 'The sequences service is not responding (timed out). Try again in a moment.',
    sequencesServiceUnexpectedResponse: 'Unexpected response from the sequences service. Try again in a moment.',
  },
  projectsStore: {
    couldNotLoadProjects: 'Could not load the projects.',
    fallbackErrorStatus: '{{fallback}} (error {{status}})',
  },
  publishingStore: {
    tenantNotFoundInTheSession: 'Tenant not found in the session — sign in again.',
  },
  settingsStore: {
    errorStatus: 'Error {{status}}',
    unknownError: 'Unknown error',
  },
  uiStore: {
    indigo: 'Indigo',
    violet: 'Violet',
    emerald: 'Emerald',
    pink: 'Pink',
    amber: 'Amber',
    sky: 'Sky',
  },
  inboxStore: {
    couldNotLoadConversations: 'Could not load the conversations.',
    couldNotLoadConversation: 'Could not load the conversation.',
  },
  workflowBuilderStore: {
    fallbackErrorStatus: '{{fallback}} (error {{status}})',
  },
};

export default en;
